import CLIENTS_WITHOUT_LINKING from "../../const/clientsWithoutLinking";
/**
 * This function checks if a clientId is part of the CLIENTS_WITHOUT_LINKING blacklist which makes the "Account ending in..." link disabled.
 * @param clientId: The client to be checked against e.g. "virgin" / "onepaywalmart"
 * @returns a boolean representing if the link is disabled or not.
 */
var isAccountLinkDisabledForAClient = function (clientId) {
    return CLIENTS_WITHOUT_LINKING.includes(clientId);
};
export default isAccountLinkDisabledForAClient;
//# sourceMappingURL=isAccountLinkDisabledForAClient.js.map